const formatDate = (date) => {
  // Data do post removido
  // return `Postdo em ${new Date(date).toLocaleDateString()}`
  return ``
}

export default formatDate
